import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import FlashCardsPage from '../../features/flash-cards/components/FlashCardsPage';

const FlashCardsRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <FlashCardsPage />
  </ProtectedRoute>
);

export default FlashCardsRoute;
